import { FullWidthPrimaryButton, PrimaryButton } from 'commonStyledComponents'
import { ColoredIcon } from 'component/ColoredIcon'
import styled from 'styled-components'
import themeAsseticonCloseSvg from '@theme/icon/close.svg'
import themeAssetbannerUpdatePng from '@theme/banner/update.png'

export const ToastWrapper = styled.div`
  position: fixed;
  left: calc(16rem / 39);
  right: calc(16rem / 39);
  bottom: calc(env(safe-area-inset-bottom) + 1.35rem + calc(16rem / 39));
  padding: calc(16rem / 39);
  z-index: 1;
  background-color: var(--main-background);
  color: var(--main-color);
  border-radius: calc(8rem / 39);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: calc(14rem / 39);
  box-shadow: 0px calc(4rem / 39) calc(9rem / 39) rgba(0, 0, 0, 0.5);
`
export const ToastControlWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: calc(8rem / 39);
`
export const BtnCancel = styled(ColoredIcon).attrs({
  src: `${themeAsseticonCloseSvg}`,
})`
  width: calc(16rem / 39);
  height: calc(16rem / 39);
`
export const BtnClose = styled.button`
  width: calc(32rem / 39);
  height: calc(32rem / 39);
  background-image: url(${themeAsseticonCloseSvg});
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  top: 0.4rem;
  right: 0.4rem;
`

export const ToastButton = styled(PrimaryButton)`
  padding: calc(4rem / 39) calc(8rem / 39);
  border-radius: calc(4rem / 39);
  font-size: calc(12rem / 39);
  margin: calc(-4rem / 39) 0;
`

export const MaintenancePageWrapper = styled.div`
  display: flex;
  position: fixed;
  inset: 0 0 0 0;
  flex-direction: column;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: calc(var(--layer-fullpage-modal) + 1);
  color: #fff;
  text-align: center;
  align-items: center;
`

export const UserCardWrapper = styled.div`
  position: relative;
`

export const TutorialWrapper = styled.div`
  position: relative;
  overflow: auto;
  width: calc(100% - 0.82rem);
  height: calc(100% - 0.82rem);
  border-radius: 0.25rem;
  background: white;
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
`

export const TutorialImg = styled.img`
  width: 100%;
`

export const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 7.89rem;
  height: 9.94rem;
  background-color: white;
  border-radius: 0.25rem;
  overflow: hidden;
`
export const DialogBanner = styled.div`
  background-image: url(${themeAssetbannerUpdatePng});
  background-repeat: no-repeat;
  padding-bottom: 2.56rem;
  background-size: 100% 100%;
`

// export const PageTitle = styled.div`
//   font-size: 0.4rem;
//   font-weight: 700;
//   padding-bottom: 0.6rem;
// `

export const PageContentLine = styled.div`
  font-size: 0.35rem;
  padding-bottom: 0.5rem;
`

export const PageFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  font-size: 0.4rem;
`

export const TextArea = styled.div`
  flex-grow: 1;
  padding: 0.41rem 0.41rem 0;
  color: #5a5a5a;
  font-size: 0.36rem;
  line-height: 0.58rem;
  text-align: left;
`

export const FullWidthPrimaryButtonWithMargin = styled(FullWidthPrimaryButton)`
  margin: 0.41rem;
  width: calc(100% - 0.41rem * 2);
`
// loading
export const LoadingOverlay = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: calc(var(--layer-fullpage-modal) + 1);
  background-color: rgba(0, 0, 0, 0.5);
`
